import React from 'react';
import { Badge, IconButton, Tooltip } from '@mui/material';
import { Forum as ChatIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useChat } from '../../contexts/ChatContext';

/** App bar chat shortcut; only shown to members of at least one chat channel. */
const ChatNavButton = () => {
  const { channels, hasNewMessages } = useChat();
  if (!channels.length) return null;

  const label = hasNewMessages ? 'Chat (new messages)' : 'Chat';
  return (
    <Tooltip title={label}>
      <IconButton component={Link} to="/chat" color="inherit" aria-label={label}>
        <Badge variant="dot" color="error" overlap="circular" invisible={!hasNewMessages}>
          <ChatIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default ChatNavButton;
